import React from 'react';
import type { PercentileLevel } from '@talentmesh/utils';
import { TypographyH4 } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import ResultsTalentScoreCircularProgress from './ResultsTalentScoreCircularProgress';

interface CandidateResultTalentScoreGroupProps {
    level: PercentileLevel;
    progress?: number;
}

function CandidateResultTalentScoreGroup({ level, progress }: CandidateResultTalentScoreGroupProps): React.JSX.Element {
    return (
        <div className="flex flex-row items-center gap-2">
            <TypographyH4>{UIStrings.TalentScore}</TypographyH4>
            <ResultsTalentScoreCircularProgress level={level} progress={progress} />
        </div>
    );
}

export default CandidateResultTalentScoreGroup;
